
import Editor from "./editor";
import { Component, Vue } from "vue-property-decorator";
@Component({
  mixins: [Editor],
})
export default class NumberEditor extends Vue {}
